// extracted by mini-css-extract-plugin
export var arrow = "_c-8";
export var fadeIn = "_c-1";
export var header = "_c-4";
export var image = "_c-3";
export var link = "_c-7";
export var modal = "_c-2";
export var overlay = "_c-0";
export var subtitle = "_c-6";
export var title = "_c-5";